<script setup>
const props = defineProps({
  size: {
    type: String,
    default: "small" // types: small/large
  },
  color: {
    type: String,
    default: "gray" // types: gray/white/dark
  }
});
</script>

<template>
  <div
    class="spinner"
    :class="['spinner--' + props.size, 'spinner--' + props.color]"
  />
</template>

<style scoped lang="scss">
.spinner {
  border: 2px solid #FFF;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;

  // Цвета спиннера
  // Используется на белом фоне.
  &--gray {
    border-color: #DEDEDE;
    border-bottom-color: transparent;
  }
  // Используется на темном фоне
  &--white {
    border-color: #FFFFFF;
    border-bottom-color: transparent;
  }
  // Используется на сером фоне.
  &--dark {
    border-color: #7B87A5;
    border-bottom-color: transparent;
  }

  // Размер спиннера

  &--small {
    width: 16px;
    height: 16px;
  }

  &--large {
    width: 44px;
    height: 44px;
  }
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>